import { render, staticRenderFns } from "./BlockContents.vue?vue&type=template&id=b218bc46"
import script from "./BlockContents.vue?vue&type=script&lang=js"
export * from "./BlockContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports